window.videoSequence = window.videoSequence || {
    initialized: false,
    videos: null,
    current: 0,
    isPaused: false,
    timerId: null,
    popup: null,
    clonedVideo: null,
    productSwiper: null,
    prevBtn: null,
    nextBtn: null,
    soundBtn: null,
    footer: null,
    footer_nav: null,
    popupIndex: 0,
    init() {
        this.initialized = true;
        this.videos = document.querySelectorAll('.loop-sequence');
        if (!this.videos.length) return;
        this.bind();
        this.start();
    },
    start() {
        if (this.isPaused) this.isPaused = false;
        this.playNext();
    },
    stop() {
        this.isPaused = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.videos.forEach(v => {
            v.pause();
            v.currentTime = 0;
        });
    },
    playNext() {
        if (this.isPaused) return;
        if (this.current >= this.videos.length) this.current = 0;
        this.videos.forEach(v => v.pause());
        const video = this.videos[this.current];
        video.currentTime = 0;
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
        this.timerId = setTimeout(() => {
            if (this.isPaused) return;
            video.pause();
            this.current++;
            this.playNext();
        }, 10000);
    },
    bind() {
        this.videos.forEach(video => {
            video.addEventListener('click', (event) => this.onVideoClick(event, video));
        });
    },
    onVideoClick(event, video) {
        event.stopPropagation();
        this.stop();
        this.videos.forEach(v => v.pause());
        this.createPopup();
        this.showPopup();
        this.populateFromVideo(video);
    },
    createPopup() {
        if (this.popup) return;
        const popup = document.createElement('div');
        popup.className = 'video-popup';
        this.popup = popup;

        const closeBtn = document.createElement('a');
        closeBtn.href = '#';
        closeBtn.className = 'close icon-button';
        closeBtn.innerHTML = '<svg width="64" height="64" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M507.3 155.3C513.5 149.1 513.5 138.9 507.3 132.7C501.1 126.5 490.9 126.5 484.7 132.7L320 297.4L155.3 132.7C149.1 126.5 138.9 126.5 132.7 132.7C126.5 138.9 126.5 149.1 132.7 155.3L297.4 320L132.7 484.7C126.5 490.9 126.5 501.1 132.7 507.3C138.9 513.5 149.1 513.5 155.3 507.3L320 342.6L484.7 507.3C490.9 513.5 501.1 513.5 507.3 507.3C513.5 501.1 513.5 490.9 507.3 484.7L342.6 320L507.3 155.3z"/></svg>';
        closeBtn.addEventListener('click', (event) => {
            event.preventDefault();
            this.hidePopup();
            this.start();
        });
        popup.appendChild(closeBtn);

        this.prevBtn = document.createElement('a');
        this.prevBtn.href = '#';
        this.prevBtn.className = 'prev icon-button';
        this.prevBtn.innerHTML = '&#8249;';

        this.nextBtn = document.createElement('a');
        this.nextBtn.href = '#';
        this.nextBtn.className = 'next icon-button';
        this.nextBtn.innerHTML = '&#8250;';

        this.soundBtn = document.createElement('a');
        this.soundBtn.href = '#';
        this.soundBtn.className = 'sound icon-button';
        this.soundBtn.innerHTML = '<svg class="on" width="64" height="64" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M176 384L112 384C103.2 384 96 376.8 96 368L96 272C96 263.2 103.2 256 112 256L176 256C184.5 256 192.6 252.6 198.6 246.6L316.7 128.6C317.1 128.2 317.6 128 318.1 128C319.2 128 320 128.9 320 129.9L320 510C320 511.1 319.1 511.9 318.1 511.9C317.6 511.9 317.1 511.7 316.7 511.3L198.6 393.4C192.6 387.4 184.5 384 176 384zM176 224L112 224C85.5 224 64 245.5 64 272L64 368C64 394.5 85.5 416 112 416L176 416L294.1 534.1C300.5 540.5 309.1 544 318.1 544C336.8 544 352 528.8 352 510.1L352 130C352 111.3 336.8 96.1 318.1 96.1C309.1 96.1 300.5 99.7 294.1 106L176 224zM419.2 246.4C413.9 253.5 415.3 263.5 422.4 268.8C438 280.5 448 299.1 448 320C448 340.9 438 359.5 422.4 371.2C415.3 376.5 413.9 386.5 419.2 393.6C424.5 400.7 434.5 402.1 441.6 396.8C464.9 379.3 480 351.4 480 320C480 288.6 464.9 260.7 441.6 243.2C434.5 237.9 424.5 239.3 419.2 246.4zM506.2 171.9C499.4 166.3 489.3 167.2 483.7 174C478.1 180.8 479 190.9 485.8 196.5C521.4 225.9 544 270.3 544 320C544 369.7 521.4 414.1 485.8 443.4C479 449 478 459.1 483.7 465.9C489.4 472.7 499.4 473.7 506.2 468.1C548.8 432.9 576 379.6 576 320C576 260.4 548.8 207.1 506.2 171.9z"/></svg><svg width="64" height="64" class="off" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M166.6 393.4L284.7 511.4C285.1 511.8 285.6 512 286.1 512C287.2 512 288 511.1 288 510.1L288 130C288 128.9 287.1 128.1 286.1 128.1C285.6 128.1 285.1 128.3 284.7 128.7L166.6 246.6C160.6 252.6 152.5 256 144 256L80 256C71.2 256 64 263.2 64 272L64 368C64 376.8 71.2 384 80 384L144 384C152.5 384 160.6 387.4 166.6 393.4zM80 224L144 224L262.1 105.9C268.5 99.5 277.1 96 286.1 96C304.8 96 320 111.2 320 129.9L320 510C320 528.7 304.8 543.9 286.1 543.9C277.1 543.9 268.5 540.3 262.1 534L144 416L80 416C53.5 416 32 394.5 32 368L32 272C32 245.5 53.5 224 80 224zM404.7 244.7C410.9 238.5 421.1 238.5 427.3 244.7L480 297.4L532.7 244.7C538.9 238.5 549.1 238.5 555.3 244.7C561.5 250.9 561.5 261.1 555.3 267.3L502.6 320L555.3 372.7C561.5 378.9 561.5 389.1 555.3 395.3C549.1 401.5 538.9 401.5 532.7 395.3L480 342.6L427.3 395.3C421.1 401.5 410.9 401.5 404.7 395.3C398.5 389.1 398.5 378.9 404.7 372.7L457.4 320L404.7 267.3C398.5 261.1 398.5 250.9 404.7 244.7z"/></svg>';
        this.soundBtn.addEventListener('click', (event) => {
            event.preventDefault();
            if (this.clonedVideo) {
                if (this.clonedVideo.muted || this.clonedVideo.volume === 0) {
                    this.clonedVideo.muted = false;
                    this.clonedVideo.volume = 1;
                    this.soundBtn.classList.add('active');
                } else {
                    this.clonedVideo.muted = true;
                    this.clonedVideo.volume = 0;
                    this.soundBtn.classList.remove('active');
                }
            }
        });

        this.footer = document.createElement('div');
        this.footer.className = 'popup-footer';
        this.footer_nav = document.createElement('div');
        this.footer_nav.className = 'popup-footer-nav';
        this.footer.appendChild(this.soundBtn);
        this.footer_nav.appendChild(this.prevBtn);
        this.footer_nav.appendChild(this.nextBtn);
        this.footer.appendChild(this.footer_nav);

        this.clonedVideo = document.createElement('video');
        popup.appendChild(this.clonedVideo);
        popup.appendChild(this.footer);

        document.body.appendChild(popup);

        this.prevBtn.addEventListener('click', (e) => { e.preventDefault(); this.populateAt(this.popupIndex - 1); });
        this.nextBtn.addEventListener('click', (e) => { e.preventDefault(); this.populateAt(this.popupIndex + 1); });
    },

    populateFromVideo(video) {
        this.popupIndex = Array.from(this.videos).indexOf(video);
        this.populateAt(this.popupIndex);
    },

    populateAt(index) {
        this.popupIndex = (index + this.videos.length) % this.videos.length;
        const srcVideo = this.videos[this.popupIndex];
        const newVideo = srcVideo.cloneNode(true);
        if (this.clonedVideo && this.clonedVideo.parentNode) {
            this.popup.replaceChild(newVideo, this.clonedVideo);
        } else {
            this.popup.insertBefore(newVideo, this.footer);
        }
        this.clonedVideo = newVideo;
        this.clonedVideo.muted = true;
        this.clonedVideo.volume = 0;
        this.soundBtn.classList.remove('active');
        this.clonedVideo.currentTime = 0;
        this.clonedVideo.addEventListener('loadeddata', () => {
            const p2 = this.clonedVideo.play();
            if (p2 && typeof p2.catch === 'function') p2.catch(() => {});
        }, { once: true });

        const existingProducts = this.popup.querySelector('.products');
        if (existingProducts) existingProducts.remove();
        const prod = srcVideo.parentElement.querySelector('.products');
        if (prod) {
            const clonedProducts = prod.cloneNode(true);
            clonedProducts.style.removeProperty('display');
            clonedProducts.style.display = '';
            ['hidden','visually-hidden','d-none'].forEach(c => clonedProducts.classList.remove(c));

            if (this.productSwiper) {
                this.productSwiper.destroy(true, true);
                this.productSwiper = null;
            }

            clonedProducts.classList.add('swiper', 'video-popup-products');
            clonedProducts.style.overflow = 'visible';
            const children = Array.from(clonedProducts.children);
            const wrapper = document.createElement('div');
            wrapper.className = 'swiper-wrapper';
            children.forEach(child => {
                const slide = document.createElement('div');
                slide.className = 'swiper-slide video-popup-slide';
                slide.style.flex = '0 0 85%';
                slide.style.maxWidth = '85%';
                slide.style.width = '85%';
                slide.style.boxSizing = 'border-box';
                slide.appendChild(child);
                wrapper.appendChild(slide);
            });
            clonedProducts.innerHTML = '';
            clonedProducts.appendChild(wrapper);

            const pagination = document.createElement('div');
            pagination.className = 'swiper-pagination';
            clonedProducts.appendChild(pagination);

            /*const navPrev = document.createElement('div');
            navPrev.className = 'swiper-button-prev';
            clonedProducts.appendChild(navPrev);
            const navNext = document.createElement('div');
            navNext.className = 'swiper-button-next';
            clonedProducts.appendChild(navNext);*/

            this.popup.insertBefore(clonedProducts, this.popup.firstChild);

            this.productSwiper = new Swiper(clonedProducts, {
                loop: false,
                slidesPerView: 'auto',
                centeredSlides: false,
                spaceBetween: 16,
                autoplay: { delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: false },
                pagination: { el: pagination, clickable: true },
                /*navigation: { nextEl: navNext, prevEl: navPrev }*/
            });
            if (this.productSwiper && typeof this.productSwiper.update === 'function') {
                requestAnimationFrame(() => {
                    if (this.productSwiper) {
                        if (typeof this.productSwiper.updateSlides === 'function') this.productSwiper.updateSlides();
                        this.productSwiper.update();
                    }
                });
            }
            if (this.productSwiper && this.productSwiper.autoplay) {
                try { this.productSwiper.autoplay.start(); } catch (e) {}
            }
        }
    },
    showPopup() {
        if (!this.popup) return;
        if (!document.body.contains(this.popup)) document.body.appendChild(this.popup);
        this.popup.style.removeProperty('display');
        if (this.productSwiper) {
            if (typeof this.productSwiper.updateSlides === 'function') this.productSwiper.updateSlides();
            this.productSwiper.update();
        }
        if (this.productSwiper && this.productSwiper.autoplay) {
            try { this.productSwiper.autoplay.start(); } catch (e) {}
        }
    },
    hidePopup() {
        if (!this.popup) return;
        if (this.clonedVideo) {
            try { this.clonedVideo.pause(); } catch (e) {}
            this.clonedVideo.currentTime = 0;
            this.clonedVideo.muted = true;
            this.clonedVideo.removeAttribute('src');
            this.clonedVideo.querySelectorAll('source').forEach(s => s.remove());
            this.clonedVideo.load();
        }
        if (this.productSwiper) {
            try { this.productSwiper.destroy(true, true); } catch (e) {}
            this.productSwiper = null;
        }
        this.popup.style.display = 'none';
    },
    play() { this.start(); }
};

document.addEventListener('DOMContentLoaded', () => {
    if (!window.videoSequence.initialized) {
        window.videoSequence.init();
    }
});
